import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import { FormattedMessage, useIntl } from "react-intl";
const useVacacinesItem = () => {
  const icons = {
    CategoryOutlinedIcon,
    LocationCityOutlinedIcon,
  };

  const vacacinesItems = {
    id: "group-Jobs",
    title: (
      <FormattedMessage id="Vacancies Management">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    // url: "/list-of-vacancies",
    type: "group",
    icon: icons.CategoryOutlinedIcon,
    children: [
      {
        id: "lisofvacancies",
        title: <FormattedMessage id="Vacancies" />,
        type: "item",
        url: "/vacancies",
        icon: icons.CategoryOutlinedIcon,
        breadcrumbs: false,
      },
      // {
      //   id: "lisofvacancies",
      //   title: <FormattedMessage id="Vacancies List" />,
      //   type: "item",
      //   url: "/vacancies-list",
      //   icon: icons.CategoryOutlinedIcon,
      //   breadcrumbs: false,
      // },
      {
        id: "deactivatedsoon",
        title: <FormattedMessage id="Expired Soon Vacancies" />,
        type: "item",
        url: "/deactivated-soon",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      /*
      {
        id: "incoming-job-applications",
        title: <FormattedMessage id="Applications List" />,
        type: "item",
        url: "/incoming-job-applications",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      */
      {
        id: "applications-list",
        title: <FormattedMessage id="Applications List" />,
        type: "item",
        url: "/applications-list",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      /*
      {
        id: "vacanciespackagesendssoon",
        title: <FormattedMessage id="vacanciespackagesendssoon" />,
        type: "item",
        url: "/vacancies-packages-ends-soon",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "classifieds",
        title: <FormattedMessage id="classifieds" />,
        type: "item",
        url: "/classifieds",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },*/
    ],
  };

  return vacacinesItems;
};

export default useVacacinesItem;
